"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONService = void 0;
var JSONParse = require("json-parse-safe");
var JSONService = /** @class */ (function () {
    function JSONService() {
    }
    JSONService.prototype.parse = function (stringJson) {
        var jsonSafe = JSONParse(stringJson);
        if (!jsonSafe.value || jsonSafe.error) {
            if (jsonSafe.error) {
                // tslint:disable-next-line
                console.warn(jsonSafe.error.message);
            }
            return null;
        }
        return jsonSafe.value;
    };
    return JSONService;
}());
var service = new JSONService();
exports.JSONService = service;
